import { defineMessages } from 'react-intl';

export const AdministrationTabMessages = defineMessages({
  administrationHeader: {
    id: 'administration.header',
    defaultMessage: 'Administration',
  },
  tenantSettingsLabel: {
    id: 'administration.tab.tenantSettings.label',
    defaultMessage: 'Tenant',
  },
  individualisationLabel: {
    id: 'administration.tab.individualisation.label',
    defaultMessage: 'Customization',
  },
  projectTypes: {
    id: 'administration.tab.projectTypes.label',
    defaultMessage: 'Project types',
  },
  estimationMethodologies: {
    id: 'administration.tab.estimationMethodologies.label',
    defaultMessage: 'Methodologies',
  },
  estimationModels: {
    id: 'administration.tab.estimationModelsDetail.label',
    defaultMessage: 'Models',
  },
  users: {
    id: 'administration.tab.users.label',
    defaultMessage: 'Users',
  },
  workflow: {
    id: 'administration.tab.workflow.label',
    defaultMessage: 'Workflow',
  },
  aiWizard: {
    id: 'administration.tab.aiWizard.label',
    defaultMessage: 'AI Advisory',
  },
  exportSettings: {
    id: 'administration.tab.exportSettings.label',
    defaultMessage: 'Export Settings',
  },
  notificationSettings: {
    id: 'administration.tab.notificationSettings.label',
    defaultMessage: 'Notification Settings',
  },
  notificationTemplates: {
    id: 'administration.tab.notificationTemplates.label',
    defaultMessage: 'Notification templates',
  },
  notifications: {
    id: 'administration.tab.notifications.label',
    defaultMessage: 'Notifications',
  },
  tipsNews: {
    id: 'administration.tab.tipsNews.label',
    defaultMessage: 'Tips & News',
  },
  usageAnalytics: {
    id: 'administration.tab.usageAnalytics.label',
    defaultMessage: 'Usage Analytics',
  },
});
